<template>
    <div>
        <breadCrumb 
            :icon="'fa-user-check'"
            :category="$t(`sideNav.navSalonReport`)"
            :subCategory="$t(`subMenu.salon_report_attendance`)"
            :subSubCategory="''">
        </breadCrumb>
        <div class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr border-bottom-0 pt-3 d-block">
                    <attendanceFilter ref="attendanceFilter" @filterAttendanceItem="filterAttendanceItems"></attendanceFilter>
                </div>
                <div class="panel-container show">
                    <div class="panel-content">
                        <div class="tab-content mt-2">
                            <attendanceList ref="attendanceList" @setStaffFilter="setStaffFilter" @setExportData="setExportData"></attendanceList>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import BreadCrumb from './../../Bread_Crumb'
import AttendanceFilter from './Attendance_Filter'
import AttendanceList from './Attendance_List'

export default {
    name: "reportCredit",
    components:{
        AttendanceFilter, AttendanceList, BreadCrumb
    },
    data(){
        return {
            filterObj: {}, 
        }
    },
    methods:{
        filterAttendanceItems(filterObj){
            this.filterObj = filterObj;
            this.$refs.attendanceList.setAttendanceItems(this.filterObj);
        },
        setStaffFilter(data, staff){
            this.$refs.attendanceFilter.setStaffFilter(data, staff)
        },
        setExportData(data){
            this.$refs.attendanceFilter.setExportData(data)
        },
    }
}
</script>
<style scoped>
.nav-link{
    cursor: pointer;
}
</style>